import { render, staticRenderFns } from "./gift-received-modal.vue?vue&type=template&id=475f41bf"
import script from "./gift-received-modal.vue?vue&type=script&lang=js"
export * from "./gift-received-modal.vue?vue&type=script&lang=js"
import style0 from "./gift-received-modal.vue?vue&type=style&index=0&id=475f41bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports